import React from "react";
import ExamAnswerSheetState, {
  ExamAnswerSheetProps,
} from "./ExamAnswerSheet.models";
import "./ExamAnswerSheet.scss";
import ExamResultService from "../../../services/exam/ExamResultService";
import { ExamResultsDTO } from "../../../models/dtos/exams/exam/ExamResultsDTO";
import QuestionView from "../question-view/QuestionView";
import QuestionPreview from "../question-preview/QuestionPreview";
import ExamAnswerSheetPdfDownloader from "./pdf-downloader/ExamAnswerSheetPdfDownloader";
import { ExamQuestionsView } from "../../../models/dtos/exams/questions/ExamQuestionsView";

export default class ExamAnswerSheet extends React.PureComponent<
  ExamAnswerSheetProps,
  ExamAnswerSheetState
> {
  examResultService: ExamResultService;
  constructor(props: any) {
    super(props);
    this.examResultService = new ExamResultService();
    this.state = {
      questions: [],
      showModal: false,
      showReportModal: false,
      questionAttachmentId: "",
      pendingRequest: 0,
      coursesWithQuestions: [],
      courseIds: undefined,
      structure: undefined,
    };
  }

  componentDidMount = () => {
    this.setState({ pendingRequest: 3 });
    this.getExamResultData();
    this.getQuestionData();
  };

  mapQuestion() {
    let { coursesWithQuestions, questions, structure, courseIds } = this.state;

    if (structure != undefined && structure != null) {
      var groups: { questions: any[]; orderId: number; title: string }[] =
        structure.map((structureItem, index) => {
          return {
            orderId: index,
            title: structureItem.groupTitle,
            questions:
              questions?.filter(
                (question) =>
                  structureItem.courseIds.indexOf(question.courseId) != -1
              ) ?? [],
          };
        });

      let from: number = 1;
      groups.map((group) => {
        coursesWithQuestions.push({
          courseTitle: group.title ?? null,
          questions: group.questions.map((question: any, index: number) => {
            return { ...question, index: from + index };
          }),
          orderId: group.orderId,
        });
        from += group.questions.length;
        return coursesWithQuestions;
      });
    } else {
      const groupByQuestions = questions.reduce((group: any, question) => {
        const { courseTitle } = question;

        if (courseTitle !== null) {
          group[courseTitle] = group[courseTitle] ?? [];
          group[courseTitle].push(question);
          return group;
        } else {
          return question;
        }
      }, {});

      let from: number = 1;
      Object.entries(groupByQuestions).map((item: any) => {
        coursesWithQuestions.push({
          courseTitle: item[0] ?? null,
          questions: item[1].map((question: any, index: number) => {
            return { ...question, index: from + index };
          }),
          orderId: questions?.filter(
            (question) => question.courseTitle == item[0]
          )[0].courseId,
        });
        from += item[1].length;
        return coursesWithQuestions;
      });

      if (courseIds != undefined && courseIds != null && courseIds.length > 0) {
        // coursesWithQuestions = coursesWithQuestions.sort(
        //   (a, b) => courseIds.indexOf(a.orderId) - courseIds.indexOf(b.orderId)
        // );
      }
    }

    this.setState({ coursesWithQuestions: coursesWithQuestions });
    this.forceUpdate();
  }

  openPreviewModal = (attachmentId: string) => {
    this.setState({ showModal: true, questionAttachmentId: attachmentId });
  };

  closePreviewModal = () => {
    this.setState({ showModal: false });
  };

  getExamResultData = () => {
    let self = this;
    this.examResultService
      .getExamResult(Number(this.props.examResultId))
      .then(function (response) {
        self.setState({ examResult: response });
      })
      .finally(() =>
        self.setState({ pendingRequest: self.state.pendingRequest - 1 })
      );
  };

  getQuestionData = () => {
    let self = this;

    this.examResultService
      .getAnswerSheet(Number(this.props.examResultId))
      .then(function (response) {
        self.setState({ questions: response });
        self.examResultService
          .getExamStructure(Number(self.props.examResultId))
          .then(function (response) {
            self.setState(
              {
                structure: response.structure,
                courseIds: response.courseIds,
              },
              () => {
                self.mapQuestion();
              }
            );
          })
          .finally(() =>
            self.setState({ pendingRequest: self.state.pendingRequest - 1 })
          );
      })
      .finally(() =>
        self.setState({ pendingRequest: self.state.pendingRequest - 1 })
      );
  };

  renderQuestionView = (questions: any[]) => {
    return questions.map((question, key) => {
      return (
        <QuestionView
          key={key}
          examTimeExpired={true}
          isReadyOnly={true}
          onHandleAnswer={null}
          onHandleShowQuestionImage={this.openPreviewModal}
          onHandleShowQuestionReport={null}
          question={question}
          showAllQuestion={false}
          studentAnswer={[]}
        />
      );
    });
  };

  render(): React.ReactNode {
    let { examResult, questions, pendingRequest, coursesWithQuestions } =
      this.state;
    return (
      <>
        <div className="col-12 exam-answer-sheet-area notspace f-s-14">
          <QuestionPreview
            showModal={this.state.showModal}
            onClose={this.closePreviewModal}
            attachmentId={this.state.questionAttachmentId}
          />
          <div className="dropdown-list">
            {examResult !== null && examResult !== undefined ? (
              this.headerView(examResult)
            ) : (
              <></>
            )}

            {coursesWithQuestions.map((coursesWithQuestion, key) => {
              return (
                <div key={key}>
                  <div className={"area-course-title"}>
                    <label>
                      {coursesWithQuestion.courseTitle} ({" "}
                      {coursesWithQuestion.questions.length} سوال )
                    </label>
                  </div>
                  {this.renderQuestionView(coursesWithQuestion.questions)}
                </div>
              );
            })}

            {/* <div className="col-12 notspace">
                        <button className="btn btn-primary tk-full-width" >بازگشت</button>
                    </div> */}
          </div>
        </div>
        {examResult && pendingRequest == 0 && (
          <ExamAnswerSheetPdfDownloader
            questions={questions}
            coursesWithQuestions={coursesWithQuestions}
            examDetails={examResult}
          />
        )}
      </>
    );
  }

  headerView(examDetails: ExamResultsDTO) {
    let timeView: any;
    if (
      examDetails.responseDurationHour === 0 &&
      examDetails.responseDurationMinute === 0
    )
      timeView = <span>کمتر از یک دقیقه</span>;
    else
      timeView = (
        <>
          <span style={{ direction: "ltr" }}>
            {examDetails.responseDurationHour === 0
              ? "00"
              : examDetails.responseDurationHour > 0 &&
                examDetails.responseDurationHour < 10
              ? "0" + examDetails.responseDurationHour.toString()
              : examDetails.responseDurationHour}{" "}
            :{" "}
            {examDetails.responseDurationMinute === 0
              ? "00"
              : examDetails.responseDurationMinute > 0 &&
                examDetails.responseDurationMinute < 10
              ? "0" + examDetails.responseDurationMinute.toString()
              : examDetails.responseDurationMinute}
          </span>
        </>
      );
    return (
      <>
        <div className="row">
          <div className="col-6">
            <div className="tk-card exam-result-box-area">
              <label className="key">تمام سوالات</label>
              <label className="value">{examDetails.totalQuestions}</label>
            </div>
          </div>
          <div className="col-6">
            <div className="tk-card exam-result-box-area">
              <label className="key">سوالات غلط</label>
              <label className="value">{examDetails.wrongAnswers}</label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="tk-card exam-result-box-area">
              <label className="key">سوالات بدون پاسخ</label>
              <label className="value">{examDetails.nonAnswers}</label>
            </div>
          </div>
          <div className="col-6">
            <div className="tk-card exam-result-box-area">
              <label className="key">مدت پاسخگویی</label>
              <label className="value">{timeView}</label>
            </div>
          </div>
        </div>
      </>
    );
  }
}
